import { render } from "./ArticleDisplay.vue?vue&type=template&id=7e71f53f"
import script from "./ArticleDisplay.vue?vue&type=script&lang=js"
export * from "./ArticleDisplay.vue?vue&type=script&lang=js"

import "./ArticleDisplay.vue?vue&type=style&index=0&id=7e71f53f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__